import styled from 'styled-components';

export const FeeDetailsWrapper = styled.div`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const Separator = styled.span`
  height: 12px;
  width: 1px;
  background-color: ${({ theme }) => theme.palette.NL50};
`;
export const Title = styled.span`
  padding-right: 10px;
`;
export const FeeDetailsLabel = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.NL800};
  text-decoration: underline;
  margin-top: 2px;
`;

export const FeeDetailsItem = styled.span`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 10px;
  line-height: 2;
  color: ${({ theme }) => theme.palette.white};
`;

export const FeeDetailsDueHotelLabel = styled.span`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  font-size: 10px;
  line-height: 2;
  color: ${({ theme }) => theme.palette.white};
`;
